import { canonicalize } from '@meteor/canonicalize';
import { createLoader } from '@meteor/data-hooks';
import { useRef, useState } from 'react';
import { withManagementSDK } from '../../management';

export let clientGroupsLoader = createLoader({
  name: 'clientGroups',
  hash: i => canonicalize(i),
  fetch: (i: {
    instanceId: string;
    userId?: string;
    cursor?: string;
    withDeleted?: boolean;
  }) => withManagementSDK(i, sdk => sdk.instances.groups.list(i.instanceId, i)),
  mutators: {
    create: (i: {
      instanceId: string;
      name: string;
      policyId?: string;
      metadata?: Record<string, any>;
    }) => withManagementSDK(i, sdk => sdk.instances.groups.create(i.instanceId, i))
  }
});

export let useClientGroups = (instanceId: string | null, userId?: string | null) => {
  let [cursor, setCursor] = useState<string>();

  let groups = clientGroupsLoader.use(
    instanceId ? { instanceId, cursor, userId: userId || undefined } : null
  );

  let dataRef = useRef(groups.data);
  dataRef.current = groups.data;

  return {
    ...groups,
    next: () => {
      let c = dataRef.current?.pagination.afterCursor;
      if (c) setCursor(c);
    },
    previous: () => {
      let c = dataRef.current?.pagination.beforeCursor;
      if (c) setCursor(c);
    },
    createMutator: groups.useMutator('create')
  };
};

export let clientGroupLoader = createLoader({
  name: 'clientGroup',
  fetch: (i: { groupId: string; instanceId: string }) =>
    withManagementSDK(i, sdk => sdk.instances.groups.get(i.instanceId, i.groupId)),
  mutators: {
    update: (i: {
      groupId: string;
      instanceId: string;
      name?: string;
      policyId?: string;
      metadata?: Record<string, any>;
    }) => withManagementSDK(i, sdk => sdk.instances.groups.update(i.instanceId, i.groupId, i))
  }
});

export let useClientGroup = (groupId: string | null, instanceId: string | null) => {
  let group = clientGroupLoader.use(groupId && instanceId ? { groupId, instanceId } : null);

  return {
    ...group,
    updateMutator: group.useMutator('update')
  };
};
